import { Event } from "../types";

export const EVENT_DATA: Event = {
  _id: "visa-connect-ethiopia-2025",
  title: "Visa Connect Ethiopia 2025",
  description:
    "Join us for an exclusive evening of innovation, networking, and partnership opportunities. Connect with industry leaders, discover cutting-edge payment technologies, and explore collaboration opportunities that will shape the future of digital commerce in Ethiopia.",
  date: "2026-09-30T08:00:00",
  time: "8:00 AM - 5:00 PM",
  location: "Sheraton Hotel, Lalibela Ballroom",
  address: "Sheraton Addis, Taitu Street, Addis Ababa, Ethiopia",
  theme: "Innovation & Partnership",
  imageUrl:
    "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=600&fit=crop",
  createdAt: "2024-01-01T00:00:00.000Z",
  updatedAt: "2024-01-01T00:00:00.000Z",
};

export const EVENT_DETAILS = {
  date: "September 30, 2026",
  time: "8:00 AM - 5:00 PM",
  location: "Sheraton Hotel, Lalibela Ballroom",
  address: "Sheraton Addis, Taitu Street, Addis Ababa, Ethiopia",
  dressCode: "Business Casual",
  parking: "Complimentary valet parking available",
  contact: "events@visa.com | (555) 123-4567",
};
